import {ITemplateConfigSection} from './ITemplateConfigSection';
import {FormBuilder, FormGroup} from '@angular/forms';

export class Examen {

  id: number;
  code: string;
  name: string;
  sections: ITemplateConfigSection[];
  examForm: FormGroup;
  fieldList = [];
  sectionsList = [];
  configTableSegmento: any[];
  configTableSegmentoMMSS: any[];
  configTableSegmentoMMII: any[];
  configTableSegmentoSecundario: any[];
  configTableSegmentoTerciario: any[];
  configTableFooter: any[];
  baseUrl: string;
  observacionesMaxLength?: number;
  conclusionesMaxLength?: number;
  conclusionesMedicasMaxLength?: number;
  resultadosMaxLength?: number;
  ambienteDeEvaluacionMaxLength?: number;
  topodiagnosticoMaxLength?: number;
  isAttachedFileRequire = false;
  resultadoMaxLength: number;
  resultadoCuantitativoMaxLength: number;
  resultadoNoCuantitativoMaxLength: number;

  constructor(private formBuilder: FormBuilder) {
  }

  getForm(): any {
    const campos = {};
    this.sections.map((x) => {
      Object.assign(campos, x.fields);
    });
    return this.formBuilder.group(campos);
  }

  getFields(): any {
    const campos = {};
    this.sections.map((x) => {
      Object.assign(campos, x.fields);
    });
    return Object.keys(campos);
  }

  getSections(): any[] {
    const array = [];
    this.sections.map((x) => {
      array.push(x.name);
    });
    return array;
  }

  findField(nameField: string): any {
    return this.fieldList.find((x) => x === nameField);
  }

  findSection(nameSection: string): any {
    return this.sectionsList.find((x) => x === nameSection);
  }

  findNumberSection(section: string): number {
    let sectionNumber = 0;
    this.sections.map((x) => {
      if (x.name === section) {
        sectionNumber = x.numberForm;
      }
    });
    return sectionNumber;
  }
}
